import type { ViewProps } from 'react-native'
import { PositionDirection } from '~/utils/layout/position-enums'
import { useTheme, type LayoutInfo } from '~/hooks'
import * as Comp from './popover-arrow.styles'
import { ArrowSvg } from '~/components/arrow-svg'

interface TPopoverArrowProps extends ViewProps {
  side: PositionDirection
  rootLayout?: LayoutInfo
}

export function PopoverArrow({
  side,
  rootLayout,
  ...rest
}: TPopoverArrowProps) {
  const getTransform = () => {
    const theme = useTheme()

    const ARROW_SIZE = theme.sizingMicro
    const SCREEN_MARGIN = theme.sizingMicro

    if (side === PositionDirection.BOTTOM || side === PositionDirection.TOP) {
      return {
        translateX:
          (rootLayout?.x || 0) +
          (rootLayout?.width || 0) / 2 -
          ARROW_SIZE -
          SCREEN_MARGIN,
      }
    }

    return {
      translateY: 0,
    }
  }

  return (
    <Comp.Wrapper
      style={{
        transform: [getTransform()],
      }}
      side={side}
      {...rest}
    >
      <Comp.Arrow side={side}>
        <ArrowSvg />
      </Comp.Arrow>
    </Comp.Wrapper>
  )
}
